import get from 'lodash/fp/get';
import flow from 'lodash/fp/flow';
import map from 'lodash/fp/map';
import join from 'lodash/fp/join';
import sumBy from 'lodash/fp/sumBy';
import zipObject from 'lodash/fp/zipObject';
import isEmpty from 'lodash/fp/isEmpty';
import moment from 'moment-timezone';

import { getPersonName, transformShopAddress } from '../utils/helpers';
import config from '../../config';


const getWaitingListInfoProp = propName => get(['waitingList', 'waitingListInfo', propName]);

export const getWaitingListInfoShopId = getWaitingListInfoProp('shopId');
export const getWaitingListInfoBarberId = getWaitingListInfoProp('barberId');
export const getWaitingListInfoServiceIds = getWaitingListInfoProp('serviceIds');
export const getWaitingListInfoNumberInLine = getWaitingListInfoProp('numberInLine');

const getWaitingListTimesProp = propName => get(['waitingList', 'waitingListTimes', propName]);


export const getWaitingListTimesBarberName = flow(
  getWaitingListInfoProp('barber'),
  getPersonName,
);

export const getWaitingListTimesServiceName = flow(
  getWaitingListTimesProp('services'),
  map('name'),
  join(', '),
);

export const getWaitingListTimesServiceDuration = flow(
  getWaitingListTimesProp('services'),
  sumBy('duration'),
);

export const getWaitingListTimesShop = flow(
  getWaitingListTimesProp('shop'),
  shop => !isEmpty(shop) && transformShopAddress(shop),
);

export const getWaitingListTimesShopName = flow(
  getWaitingListTimesShop,
  get('name'),
);

export const getWaitingListTimesShopAddress = flow(
  getWaitingListTimesShop,
  get('address'),
);

export const getWaitingListTimesShopZip = flow(
  getWaitingListTimesShop,
  get('zip'),
);

export const getWaitingListTimeShopLocation = flow(
  getWaitingListTimesShop,
  get('location.coordinates'),
  zipObject(['lat', 'lng']),
);

export const getWaitingListTimesTimezone = flow(
  getWaitingListTimesShop,
  get('timezone'),
);

export const getWaitingListTimesDay = state => flow(
  getWaitingListTimesProp('day'),
  day => moment.tz(day, getWaitingListTimesTimezone(state)).format(config.dateFormat),
)(state);

export const getWaitingListTimesTimes = getWaitingListTimesProp('times');



// WEBPACK FOOTER //
// ./src/app/waitingList/selectors.js